import { useNavigate } from 'react-router-dom';
import { featureFlags } from '../utils/featureFlags';
import { AppRoutes } from '../routes';

/**
 * Custom hook that provides navigation with feature flag awareness.
 * When auth routes are disabled, navigation to login/signup redirects to waitlist.
 */
export const useFeatureFlagNavigation = () => {
  const navigate = useNavigate();

  /**
   * Navigate to a route, respecting feature flags.
   * If navigating to login/signup and auth routes are disabled, redirects to waitlist.
   */
  const navigateTo = (route: AppRoutes) => {
    // If trying to navigate to auth routes but they're disabled, go to waitlist
    if (!featureFlags.showAuthRoutes && (route === AppRoutes.LOGIN || route === AppRoutes.SIGNUP)) {
      navigate(AppRoutes.WAITLIST);
      return;
    }

    // Otherwise navigate normally
    navigate(route);
  };

  return { navigateTo };
};
